import { Reveal } from "../components/Reveal";
import { Icon } from "../components/Icon";
import { PageHero } from "../components/PageHero";
import { CTA } from "./Home";
import { IMAGES, SERVICES } from "../data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const Block = ({ label, children }) => (
  <div>
    <p className="text-xs uppercase tracking-[0.16em] text-sora-blue font-bold mb-2">{label}</p>
    {children}
  </div>
);

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        testid="services-hero"
        eyebrow="Our Services"
        title="Speech pathology, shaped around your child."
        subtitle="Every child is different. Explore the areas we support and the evidence-based ways we help children grow."
        image={IMAGES.childPlay}
      />

      <section className="py-12">
        <div className="max-w-5xl mx-auto px-6 md:px-10 space-y-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <div data-testid={`service-detail-${i}`} className="rounded-[24px] bg-sora-warm border border-sora-stone/25 shadow-[0_8px_30px_rgba(63,88,115,0.05)] overflow-hidden">
                <div className="flex items-center gap-5 p-7 md:p-9">
                  <span className="shrink-0 grid place-items-center h-16 w-16 rounded-[20px] bg-sora-blue/12 text-sora-blue"><Icon name={s.icon} size={30} /></span>
                  <div>
                    <h2 className="font-display text-2xl md:text-3xl text-sora-slate">{s.title}</h2>
                    <p className="mt-1.5 text-sora-charcoal/75 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
                <Accordion type="single" collapsible className="px-7 md:px-9 pb-3">
                  <AccordionItem value="details" className="border-t border-sora-stone/30">
                    <AccordionTrigger data-testid={`service-accordion-${i}`} className="text-sora-slate hover:text-sora-blue hover:no-underline py-5 font-bold">
                      View details
                    </AccordionTrigger>
                    <AccordionContent className="pb-8">
                      <div className="grid md:grid-cols-2 gap-7 pt-2">
                        <Block label="Who it helps"><p className="text-sora-charcoal/80 leading-relaxed">{s.who}</p></Block>
                        <Block label="Assessment options"><p className="text-sora-charcoal/80 leading-relaxed">{s.assessment}</p></Block>
                        <Block label="Goals">
                          <ul className="space-y-1.5">{s.goals.map((g) => <li key={g} className="flex gap-2 text-sora-charcoal/80"><span className="text-sora-blue">•</span>{g}</li>)}</ul>
                        </Block>
                        <Block label="Typical activities">
                          <ul className="space-y-1.5">{s.activities.map((a) => <li key={a} className="flex gap-2 text-sora-charcoal/80"><span className="text-sora-blue">•</span>{a}</li>)}</ul>
                        </Block>
                        <Block label="Treatment options"><p className="text-sora-charcoal/80 leading-relaxed">{s.treatment}</p></Block>
                        <Block label="Expected outcomes"><p className="text-sora-charcoal/80 leading-relaxed">{s.outcomes}</p></Block>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTA />
    </div>
  );
}
